import { RefObject, useCallback, useEffect, useState } from 'react';

export function useFocus(inputRef: RefObject<HTMLElement | null>) {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = useCallback(() => setIsFocused(true), []);
  const onBlur = useCallback(() => setIsFocused(false), []);

  useEffect(() => {
    const element = inputRef.current;
    if (!element) return;

    element.addEventListener('focusin', onFocus);
    element.addEventListener('focusout', onBlur);

    return () => {
      element.removeEventListener('focusin', onFocus);
      element.removeEventListener('focusout', onBlur);
    };
  }, [inputRef, onFocus, onBlur]);

  return {
    isFocused,
    onFocus,
    onBlur,
  };
}
